import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {GestionGefService} from './gestion-gef.service';
import {ToastService} from '../technique/toast.service';
import {MSG_KEY, MSG_SEVERITY} from '../../constants';
import {ResponseWrapper} from '../../suppliers/wrappers/response-wrapper';
import {FluxCard, FluxStatus} from './flux-card.model';
import {DolFlowOrchestratorFluxDto} from '../../dtos/gef/dol-flow-orchestrator-flux-dto';

export {FluxCard, FluxDirection, FluxStatus} from './flux-card.model';
export {ProviderSection} from './provider-section.model';

@Injectable({providedIn: 'root'})
export class LanceursFluxService {

  private readonly gestionGefSvc = inject(GestionGefService);
  private readonly toastSvc      = inject(ToastService);

  loadDolApiWebhooks(): Observable<FluxCard[]> {
    return this.gestionGefSvc.getDolFlowOrchestratorSwagger().pipe(
      map((response: ResponseWrapper<DolFlowOrchestratorFluxDto>) => {
        if (response.inError) { return []; }
        return (response.resultList ?? []).map(f => ({
          id:     f.id,
          label:  f.label ?? f.id,
          status: 'idle' as FluxStatus,
        }));
      })
    );
  }

  launchElapApi(flux: FluxCard): Observable<ResponseWrapper<any>> | null {
    switch (flux.id) {
      case 'export-fournisseurs':           return this.gestionGefSvc.launchFluxExportFournisseurs(false);
      case 'export-articles':               return this.gestionGefSvc.launchFluxExportArticles(false);
      case 'export-commandes-fournisseurs': return this.gestionGefSvc.launchFluxExportCommandesFournisseurs(false);
      case 'export-bons-reception':         return this.gestionGefSvc.launchFluxExportBonsReception(false);
      default:                              return null;
    }
  }

  launchDolApi(flux: FluxCard): Observable<ResponseWrapper<any>> {
    return this.gestionGefSvc.triggerDolFlowOrchestratorFlux({id: flux.id, label: flux.label});
  }

  notifyResult(response: ResponseWrapper<any>, successMsg: string, errorMsg: string): FluxStatus {
    const inError = response.inError;
    this.toastSvc.displayToast(MSG_KEY.ROOT, inError ? MSG_SEVERITY.ERROR : MSG_SEVERITY.INFO, inError ? errorMsg : successMsg);
    return inError ? 'error' : 'success';
  }

  notifyError(msg: string): 'error' {
    this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, msg);
    return 'error';
  }
}
